// Script to properly trigger shipping protection when Add to Cart is clicked
(function() {
  // Listen for Add to Cart button clicks
  document.addEventListener('click', function(e) {
    // Check if clicked element is an Add to Cart button
    if (e.target.matches('button[name="add"]') || 
        e.target.closest('button[name="add"]')) {
      
      // Wait for cart to open after add to cart
      setTimeout(function() {
        // Find the shipping protection checkbox
        const checkbox = document.getElementById('shipping-protection');
        
        if (checkbox) {
          // Instead of just setting checked=true programmatically,
          // simulate an actual user click on the toggle
          const toggleLabel = document.querySelector('.shipping-protection-toggle-switch');
          
          if (toggleLabel && !checkbox.checked) {
            // Programmatically click the toggle to properly trigger SlideCart's handling
            toggleLabel.click();
          }
        }
      }, 550); // Give enough time for cart to open
    }
  });
})();